// Which auth-state changes are housekeeping, and which are a real change of
// who is signed in.
//
// Supabase emits an event for both. Treating them alike is what made the app
// tear itself down roughly once an hour: `onAuthStateChange` raised the
// bootstrap `loading` flag for every event, and App returns a full-screen
// spinner whenever that flag is up — unmounting the whole shell. Everything
// holding component state went with it. Reproduced directly by calling
// `auth.refreshSession()`: the guided demo jumped from step 10 back to step 1.

/**
 * True for events that carry no change of identity or authentication level.
 *
 * A refreshed access token is the same user, at the same assurance level, with
 * the same profile — there is nothing to re-derive, so the UI must not be
 * disturbed. Everything else (signing in, verifying a second factor, updating
 * the user, signing out) genuinely changes what the session may do and has to
 * be re-assessed.
 */
export function isBackgroundAuthEvent(event: string): boolean {
  return event === 'TOKEN_REFRESHED';
}
